'use client'

import { useEffect } from 'react'
import { Button } from '@/components/ui/button'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        console.error(error)
    }, [error])

    return (
        <div className='mx-auto max-w-xl space-y-4 px-6 py-24 text-center'>
            <h1 className='text-3xl font-semibold'>Something went wrong.</h1>
            <p className='text-muted-foreground'>Please try again. If the error persists, reload the page.</p>
            <Button onClick={reset}>Try again</Button>
        </div>
    )
}
